export const getGridStyles = () => ({
  root: {
    marginTop: 16,
    '& .ms-DetailsHeader': {
      borderTop: 'none',
    },
    '& .ms-DetailsRow-cell:nth-child(1)': {
      borderRight: 'none',
    },
    '& .ms-DetailsHeader-cell:nth-child(3)': {
      borderRight: 'none',
    },
  },
});
